__turbopack_context__.v({
  "react_time": "_4aSYcq_react_time",
  "react_time__animating": "_4aSYcq_react_time__animating",
});
